import { render, staticRenderFns } from "./editBalance.vue?vue&type=template&id=2ec045e0&scoped=true"
import script from "./editBalance.vue?vue&type=script&lang=ts"
export * from "./editBalance.vue?vue&type=script&lang=ts"
import style0 from "./editBalance.vue?vue&type=style&index=0&id=2ec045e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec045e0",
  null
  
)

export default component.exports